import { ArrowRight, CheckCircle2, Phone, Star } from 'lucide-react';
import { company, heroPoints, images, stats } from '../../mock';
import { Button } from '../ui/button';

export default function Hero() {
  return (
    <section
      id="home"
      className="section-anchor relative pt-32 md:pt-40 pb-20 md:pb-28 hero-pattern overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8 grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        <div className="fade-up">
          <div className="inline-flex items-center gap-2 rounded-full bg-[#0b6b5b]/10 text-[#0b6b5b] px-3.5 py-1.5 text-xs font-semibold tracking-wide">
            <span className="h-1.5 w-1.5 rounded-full bg-[#0b6b5b]" />
            ACCOUNTANT — TARARUA &amp; MANAWATU
          </div>

          <h1 className="mt-5 font-display text-[42px] sm:text-5xl lg:text-[58px] leading-[1.05] text-stone-900 font-semibold">
            Friendly, affordable
            <span className="text-[#0b6b5b]"> accounting</span>
            <br /> with a low fee promise.
          </h1>

          <p className="mt-5 text-stone-600 text-[17px] leading-relaxed max-w-xl">
            Managing your accounts, GST, payroll and end-of-year reporting no
            longer needs to be a headache. We look after the numbers — you focus
            on running your business.
          </p>

          <ul className="mt-6 space-y-2.5">
            {heroPoints.map((p) => (
              <li key={p} className="flex items-start gap-2.5 text-stone-700">
                <CheckCircle2 className="h-5 w-5 text-[#0b6b5b] mt-0.5 flex-shrink-0" />
                <span className="text-[15px]">{p}</span>
              </li>
            ))}
          </ul>

          <div className="mt-8 flex flex-wrap items-center gap-3">
            <Button asChild className="brand-btn h-12 px-6 rounded-full font-semibold text-[15px]">
              <a href="#contact">
                Book a Free Consult <ArrowRight className="h-4 w-4 ml-1" />
              </a>
            </Button>
            <Button
              asChild
              variant="outline"
              className="brand-btn-outline h-12 px-6 rounded-full font-semibold text-[15px]"
            >
              <a href={`tel:${company.phone.replace(/\s/g, '')}`}>
                <Phone className="h-4 w-4 mr-2" />
                {company.phone}
              </a>
            </Button>
          </div>

          <div className="mt-7 flex items-center gap-3">
            <div className="flex -space-x-2">
              {[1, 2, 3, 4].map((i) => (
                <div
                  key={i}
                  className="h-8 w-8 rounded-full border-2 border-white bg-gradient-to-br from-stone-200 to-stone-400"
                />
              ))}
            </div>
            <div className="flex items-center gap-1">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="h-4 w-4 fill-[#f3c14a] text-[#f3c14a]" />
              ))}
              <span className="ml-1.5 text-sm text-stone-600">
                <strong className="text-stone-900">350+</strong> happy NZ clients
              </span>
            </div>
          </div>
        </div>

        <div className="relative fade-up delay-2">
          <div className="media-card shadow-[0_30px_80px_-30px_rgba(11,107,91,0.45)]">
            <img
              src={images.hero}
              alt="Accounting workspace with calculator and reports"
              className="w-full h-[460px] lg:h-[540px] object-cover"
              loading="eager"
            />
          </div>

          <div className="absolute -bottom-6 -left-4 md:-left-10 bg-white rounded-2xl shadow-xl p-4 pr-6 flex items-center gap-3 border border-stone-100">
            <div className="h-12 w-12 rounded-xl bg-[#0b6b5b] grid place-items-center text-white">
              <CheckCircle2 className="h-6 w-6" />
            </div>
            <div>
              <div className="text-[13px] text-stone-500">Low Fee Promise</div>
              <div className="font-display font-semibold text-stone-900">
                No hidden surprises
              </div>
            </div>
          </div>

          <div className="absolute -top-5 -right-3 md:-right-6 bg-[#0b6b5b] text-white rounded-2xl shadow-xl p-4 pr-5">
            <div className="text-[11px] tracking-widest uppercase text-[#f3c14a]">Xero / MYOB</div>
            <div className="font-display font-semibold text-[15px]">Certified Partners</div>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-5 md:px-8 mt-16 md:mt-24">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {stats.map((s, i) => (
            <div
              key={s.label}
              className={`bg-white rounded-2xl border border-stone-200 p-5 md:p-6 fade-up delay-${(i % 4) + 1}`}
            >
              <div className="font-display text-3xl md:text-4xl font-semibold text-[#0b6b5b]">
                {s.value}
              </div>
              <div className="text-sm text-stone-600 mt-1">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
